export default "__VITE_ASSET__DJNR2eoB__"